import { SatDikDetail } from '@/apis/types'

import { KeyValTable } from '@/components/KeyValTable'

type Props = {
  data?: SatDikDetail
}

// eslint-disable-next-line unused-imports/no-unused-vars
export function TabKontak({ data }: Props) {
  return (
    <KeyValTable
      rows={[
        {
          key: 'fax',
          displayName: 'Fax',
          value: data?.nomorFax || '-',
        },
        {
          key: 'telepon',
          displayName: 'Telepon',
          value: data?.nomorTelepon || '-',
        },
        {
          key: 'email',
          displayName: 'Email',
          value: data?.email || '-',
        },
        {
          key: 'website',
          displayName: 'Website',
          value: data?.website || '-',
        },
      ]}
    />
  )
}
